import { useCallback, useEffect, useState } from 'react';
import { getCookie, setCookie } from 'shared/helpers/StorageHelpers';

export const DISMISS_STORAGE_PREFIX = 'sc_banner_dismissed_';
export const DISMISS_STORAGE_VALUE = '1';

export interface UseSuperCardBannerDismissResult {
  isDismissed: boolean;
  dismiss: () => void;
}

function getDismissStorageKey(placement: string): string {
  return `${DISMISS_STORAGE_PREFIX}${placement}`;
}

function readDismissed(placement: string): boolean {
  return getCookie(getDismissStorageKey(placement)) === DISMISS_STORAGE_VALUE;
}

export function useSuperCardBannerDismiss(
  placement: string,
): UseSuperCardBannerDismissResult {
  const [isDismissed, setIsDismissed] = useState(() =>
    readDismissed(placement),
  );

  useEffect(() => {
    setIsDismissed(readDismissed(placement));
  }, [placement]);

  const dismiss = useCallback(() => {
    setIsDismissed(true);
    setCookie(getDismissStorageKey(placement), DISMISS_STORAGE_VALUE);
  }, [placement]);

  return { isDismissed, dismiss };
}
